import React from 'react';
import styled from 'styled-components';
import { Grid, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

import useCurrentUserDb from '../hooks/useCurrentUserDb';
import Redirector from './Redirector';

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
`
const ContainerGrid = styled(Grid)`
  height: inherit;
  width: inherit;
`;
const AccountNameSpan = styled.span`
  text-decoration: underline;
`
const PlainLink = styled(Link)`
  text-decoration: none;
`

type DeleteAccountSceneProps = {
  redirected: boolean;
  doneRedirect: () => void;
}
const DeleteAccountScene: React.FC<DeleteAccountSceneProps> = ({ redirected, doneRedirect }) => {
  const [, user] = useCurrentUserDb();

  if (!redirected) return <Redirector doneRedirect={doneRedirect} />;
  else return (
    <Wrapper>
      <ContainerGrid container justifyContent="center" alignItems="center" direction="column" spacing={6}>
        <Grid item>
          <AccountNameSpan>{ user?.name }</AccountNameSpan><span> </span>
          様のユーザ登録を消去し、
          <br />
          デジマジの利用を解約します。
        </Grid>
        <Grid item>
          <Grid container justifyContent="flex-end" spacing={2} direction="row">
            <Grid item>
              <PlainLink to="/changePlan">
                <Button color='primary'>キャンセル</Button>
              </PlainLink>
            </Grid>
            <Grid item>
              <Button color="secondary">解約する</Button>
            </Grid>
          </Grid>
        </Grid>
      </ContainerGrid>
    </Wrapper>
  );
}

export default DeleteAccountScene;
